export default "/images/6166dd50222098b9f1153275afb9b009.avif";